/* global grecaptcha */
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { siteKey: String }

  initialize() {
    this.whenReady(() => grecaptcha.render('recaptchaV2', { sitekey: this.siteKeyValue }))
  }

  whenReady(callback) {
    if (window.grecaptcha?.render) {
      callback()
    } else {
      setTimeout(() => this.whenReady(callback), 100)
    }
  }
}
